/* ==========================================================================
   MADE TO MEASURE - cart display - J & A Doors - Codelabs
   Upload as: assets/mtp-cart.js
   Load site-wide from layout/theme.liquid, just before </body>.

   WHY THIS EXISTS
   The storefront cannot set a custom line price, so the size markup and hinge
   fee ride as a 1p charge product with quantity equal to the exact pence. The
   money is right, but raw it reads wrong: charge lines show 1p, the basket
   count balloons, and helper properties print.

   WHAT IT DOES
   - hides the charge lines entirely
   - shows the true all-in price on each door line (from that door's own pence)
   - corrects the basket count so it counts doors, not pennies
   - hides internal helper properties

   v2: each door now shows only its own charges. Charge lines are shared by
   every door of the same product and size, so two such doors used to each
   show the combined charge.
   ========================================================================== */
(function () {
  'use strict';

  var FLAG = window.MTP_FLAG_NAME || 'Order type';
  var FLAGV = window.MTP_FLAG_VALUE || 'Made to measure';
  var HIDDEN = ['_mtp', 'For'];
  var root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  var cart = null;

  function money(c) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(c, window.MTP_MONEY_FORMAT); } catch (e) {}
    return '\u00a3' + (c / 100).toFixed(2);
  }
  function squash(s) { return String(s || '').replace(/\s|\u00a0|&nbsp;/g, ''); }
  function prop(item, name) {
    var p = item.properties || {};
    for (var k in p) if (k === name) return p[k];
    return null;
  }
  function pence(item, name) { return parseInt(prop(item, name) || '0', 10) || 0; }
  function role(item) { return prop(item, '_mtp'); }
  function isMtm(item) { return prop(item, FLAG) === FLAGV; }

  function getCart() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  // matches the For property the product page writes on each charge line
  function doorKey(item) {
    var size = prop(item, 'Size (H x W)') || prop(item, 'Size (HxW)');
    return size ? (item.product_title || item.title) + ' (' + size + ')' : null;
  }

  function totals() {
    var doors = 0, pennies = 0;
    (cart.items || []).forEach(function (it) {
      if (role(it)) pennies += it.quantity;
      else doors += it.quantity;
    });
    return { doors: doors, pence: pennies };
  }

  /* ---- keep the charge lines exactly in step with the doors ----
     Charge lines merge by variant + properties, so repeated adds accumulate and
     a quantity change leaves them stale. Each door carries the per-door pence in
     _mtpM / _mtpH, so we can work out what each charge SHOULD be and correct it.
     A required quantity of 0 removes the line, which also clears orphans. */
  function reconcile() {
    var want = {};
    (cart.items || []).forEach(function (it) {
      if (role(it)) return;
      var k = doorKey(it);
      if (!k) return;
      if (!want[k]) want[k] = { markup: 0, hinge: 0 };
      want[k].markup += pence(it, '_mtpM') * it.quantity;
      want[k].hinge += pence(it, '_mtpH') * it.quantity;
    });

    var fixes = [];
    (cart.items || []).forEach(function (it) {
      var r = role(it);
      if (!r) return;
      var k = prop(it, 'For');
      var target = 0;
      if (k && want[k]) target = (r === 'hinge') ? want[k].hinge : want[k].markup;
      if (it.quantity !== target) fixes.push({ key: it.key, quantity: target });
    });
    return fixes;
  }

  var fixing = false, fixRounds = 0;
  function applyFixes(fixes) {
    if (fixing || !fixes.length) return false;
    if (fixRounds > 12) return false;          // safety, never loop forever
    fixing = true; fixRounds++;
    var f = fixes[0];
    fetch(root + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: f.key, quantity: f.quantity })
    }).then(function () { fixing = false; run(); })
      .catch(function () { fixing = false; });
    return true;
  }

  // after we change charge lines behind the theme's back, let it redraw totals
  function tellTheme() {
    ['cart:updated', 'cart:refresh'].forEach(function (n) {
      try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); } catch (e) {}
    });
  }

  function lineNodes() {
    var sel = ['.cart-item', '.cart__row', '.line-item', '.cart-line-item', '[data-cart-item]',
      'tr.cart-item', '.js-cart-item', '.cart_item', '.cart-drawer-item'].join(',');
    var out = [], seen = [];
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (n) {
      for (var i = 0; i < seen.length; i++) if (seen[i].contains(n)) return;
      seen.push(n); out.push(n);
    });
    return out;
  }

  // Themes differ wildly, so find the price by matching the money TEXT rather
  // than guessing class names. Rewrites every leaf element showing the old
  // amount, which covers unit price and line total wherever the theme puts them.
  function rewritePrice(node, item, extra) {
    var qty = item.quantity || 1;
    var oldLine = item.line_price || 0;
    var newLine = oldLine + extra;
    var oldUnit = item.price != null ? item.price : Math.round(oldLine / qty);
    var newUnit = Math.round(newLine / qty);

    // some themes expose the unit price on the line element
    var attrUnit = parseInt(node.getAttribute('data-price') || '', 10);
    if (!isNaN(attrUnit)) oldUnit = attrUnit;

    var pairs = [[oldLine, newLine], [oldUnit, newUnit]];
    var done = false;
    pairs.forEach(function (pr) {
      if (pr[0] === pr[1]) return;
      var target = squash(money(pr[0]));
      Array.prototype.forEach.call(node.querySelectorAll('*'), function (el) {
        if (el.children.length) return;
        if (squash(el.textContent) === target) { el.textContent = money(pr[1]); done = true; }
      });
    });

    if (!done) {
      // last resort: swap the bare number wherever it appears
      [[ (oldLine/100).toFixed(2), (newLine/100).toFixed(2) ],
       [ (oldUnit/100).toFixed(2), (newUnit/100).toFixed(2) ]].forEach(function (pr) {
        if (pr[0] === pr[1] || done) return;
        Array.prototype.forEach.call(node.querySelectorAll('*'), function (el) {
          if (el.children.length || done) return;
          var t = el.textContent || '';
          if (t.indexOf(pr[0]) > -1) { el.textContent = t.replace(pr[0], pr[1]); done = true; }
        });
      });
    }
    if (!isNaN(attrUnit)) node.setAttribute('data-price', String(newUnit));
    return done;
  }

  function hideHelpers(node) {
    HIDDEN.forEach(function (name) {
      Array.prototype.forEach.call(node.querySelectorAll('dt, .product-option, li, span, div, p'), function (el) {
        if (el.children.length) return;
        var txt = (el.textContent || '').trim();
        if (new RegExp('^' + name + '\\s*:', 'i').test(txt) || txt === name) {
          el.style.display = 'none';
          var dd = el.nextElementSibling;
          if (dd && dd.tagName === 'DD') dd.style.display = 'none';
          var row = el.closest('.product-option, li');
          if (row) row.style.display = 'none';
        }
      });
    });
  }

  function decorate() {
    if (!cart || !cart.items || !cart.items.length) return;
    var items = cart.items;

    // bring the charge lines back in step before drawing anything
    var fixes = reconcile();
    if (!fixes.length) {
      if (fixRounds > 0) { fixRounds = 0; tellTheme(); }   // settled, cap starts again
    } else if (applyFixes(fixes)) {
      return;
    }

    var t = totals(), nodes = lineNodes();

    items.forEach(function (item, idx) {
      var node = nodes[idx];
      if (!node && nodes.length !== items.length) {
        node = nodes.filter(function (n) {
          return n.querySelector('a[href*="' + item.handle + '"], a[href*="variant=' + item.variant_id + '"]');
        })[0];
      }
      if (!node) return;

      if (role(item)) { node.style.display = 'none'; node.setAttribute('data-mtp-hidden', role(item)); return; }
      if (!isMtm(item)) return;

      // This door's own charges only, from the pence it carries. Never total the
      // charge lines per door: they are shared by every door of the same size.
      var extra = (pence(item, '_mtpM') + pence(item, '_mtpH')) * (item.quantity || 1);
      if (extra) {
        var sig = item.key + '|' + item.quantity + '|' + extra;
        var shown = squash(node.textContent).indexOf(squash(money((item.line_price || 0) + extra))) > -1;
        // redraw if this line changed, or if the theme re-rendered it back to raw
        if (node.dataset.mtpSig !== sig || !shown) {
          if (!shown) rewritePrice(node, item, extra);
          node.dataset.mtpSig = sig;
        }
      }
      hideHelpers(node);
    });

    fixCount(t);
  }

  /* The theme counts every penny of the charge lines, so "Your cart (99+)".
     Replace the inflated number, however the theme splits the text. Only
     touched inside cart or header elements, so something like "100+ reviews"
     elsewhere on the page is left alone. */
  function fixCount(t) {
    if (!t.pence) return;
    var real = t.doors, raw = cart.item_count;
    var CTX = '[class*="cart"],[id*="cart"],[class*="Cart"],[id*="Cart"],[data-cart-count],cart-drawer,cart-count,header';
    function swap(token) {
      var m = /^(\d+)(\+?)$/.exec(token);
      if (!m) return null;
      var n = Number(m[1]);
      if (n === real && !m[2]) return null;
      if (n === raw) return String(real);
      if (m[2] === '+' && real < n) return String(real);   // theme's capped count
      return null;
    }
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), node;
    var edits = [];
    while ((node = walker.nextNode())) {
      var v = node.nodeValue;
      if (!v || !/\d/.test(v)) continue;
      var parent = node.parentElement;
      if (!parent || /^(SCRIPT|STYLE|TEXTAREA|INPUT|NOSCRIPT)$/.test(parent.tagName)) continue;
      if (parent.closest('[data-mtp-root]')) continue;
      if (!parent.closest(CTX)) continue;
      // only a bare count ("99+") or a bracketed one ("(99+)"), never numbers
      // inside other text such as "715 x 596"
      var trimmed = v.trim(), nv = v;
      if (/^\d+\+?$/.test(trimmed)) {
        var r1 = swap(trimmed);
        if (r1 !== null) nv = v.replace(trimmed, r1);
      } else {
        nv = v.replace(/\((\d+\+?)\)/g, function (all, tok) {
          var r2 = swap(tok);
          return r2 === null ? all : '(' + r2 + ')';
        });
      }
      if (nv !== v) edits.push([node, nv]);
    }
    edits.forEach(function (e) { e[0].nodeValue = e[1]; });
  }

  function run() { getCart().then(decorate).catch(function () {}); }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; decorate(); }, 80);
  });
  if (document.body) mo.observe(document.body, { childList: true, subtree: true });

  var _f = window.fetch;
  if (_f) {
    window.fetch = function () {
      var u = arguments[0] && (arguments[0].url || arguments[0]);
      var p = _f.apply(this, arguments);
      if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u)) {
        p.then(function () { setTimeout(run, 150); }).catch(function () {});
      }
      return p;
    };
  }
  document.addEventListener('mtp:added', function () { setTimeout(run, 250); });
})();